<script lang="ts">
    import { subNavs } from "../../store"
    import NavigationCard from "../layout/global/header/NavigationCard.svelte"
    import ArticleLink from "./blocks/ArticleLink.svelte"
    import ArticleFilter from "./blocks/articleSlider/ArticleFilter.svelte"
    import ArticleSlider from "./blocks/articleSlider/ArticleSlider.svelte"
    import BlackTextBox from "./blocks/BlackTextBox.svelte"
    import CreditFooterRow from "./blocks/CreditFooterRow.svelte"
    import ExternalLinks from "./blocks/ExternalLinks.svelte"
    import GrayBoxes from "./blocks/GrayBoxes.svelte"
    import HeroSlider from "./blocks/heroSlider/HeroSlider.svelte"
    import Image from "./blocks/Image.svelte"
    import ImageGallery from "./blocks/imageGallery/ImageGallery.svelte"
    import Keypoints from "./blocks/Keypoints.svelte"
    import PageNavigation from "./blocks/PageNavigation.svelte"
    import PeopleSlider from "./blocks/PeopleSlider.svelte"
    import ImageDownload from "./blocks/person/ImageDownload.svelte"
    import PreviewList from "./blocks/person/PreviewList.svelte"
    import ProfileCard from "./blocks/person/ProfileCard.svelte"
    import ProfileDetailsList from "./blocks/person/ProfileDetailsList.svelte"
    import QuoteText from "./blocks/QuoteText.svelte"
    import ShiftedImageSlider from "./blocks/ShiftedImageSlider.svelte"
    import Table from "./blocks/Table.svelte"
    import ToggleBoxes from "./blocks/ToggleBoxes.svelte"
    import TopicSlider from "./blocks/TopicSlider/TopicSlider.svelte"
    import VideoPreview from "./blocks/VideoPreview.svelte"
    import VideoTextRow from "./blocks/VideoTextRow/VideoTextRow.svelte"

    let {
        block,
        pageId,
        rowIdx = 0,
        publication_date,
        style,
        pageTemplate,
    }: {
        block?: BlockVariants & CommonBlockProperties
        pageId?: string
        rowIdx?: number
        publication_date?: string
        style?: string
        pageTemplate?: string
    } = $props()
    let subNav = $derived($subNavs.find((nav) => nav?.[0]?.includes(pageId)))
    const isBlockHidden = (b?: BlockVariants & CommonBlockProperties) => {
        const flag = b?.isHidden
        return flag === true || flag === "true" || flag === 1 || flag === "1"
    }
    const isHidden = $derived(isBlockHidden(block))
    const defaultWidthsAndAlignments: Record<string, { block_width: string; align_content: string }> = {
        text: {
            block_width: "column",
            align_content: "left",
        },
    }
    let items = $derived(subNav?.[1]?.subnavigation_based)
</script>

{#snippet Block()}
    <section
        class="block height-{block.content['min_height']} {block.content['margin-top']} {block.content[
            'margin-bottom'
        ]} {block.type} width-{block.content.block_width || defaultWidthsAndAlignments[block.type]?.block_width}"
        {style}
    >
        {#if block.content.hastitle}
            {#if block.content.titletype == "h1"}
                <h1 class="h2 {block.content.titlemargin}">{block.content.title}</h1>
            {:else if block.content.titletype == "h2"}
                <h2 class={block.content.titlemargin} id={rowIdx > 0 ? `row-${rowIdx}` : Math.random().toString(36)}>
                    {block.content.title}
                </h2>
            {:else if block.content.titletype == "h3"}
                <h3 class={block.content.titlemargin}>{block.content.title}</h3>
            {:else if block.content.titletype == "grayOne"}
                <em class={block.content.titlemargin}>{block.content.title}</em>
            {/if}
        {/if}

        {#if block.type == "heroSlider"}
            <HeroSlider
                slides={block.content.slides}
                {publication_date}
                autoSwipe={block.content.auto_swipe}
                swipeTimeout={block.content.swipe_timeout}
            />
        {:else if block.type == "splittedHeroRow"}
            <HeroSlider splittedSlide={block} />
        {:else if block.type == "articlesPreview"}
            <ArticleSlider articlesPreview={block.content} {pageTemplate} />
        {:else if block.type == "articleFilter"}
            <ArticleFilter filterType={block.content.filtertype} />
        {:else if block.type == "text"}
            <QuoteText content={block.content} />
        {:else if block.type == "blackTextBlock"}
            <BlackTextBox {block} />
        {:else if block.type == "personSmallPreviewCards"}
            <ProfileCard {block} />
        {:else if block.type == "downloadablePreviewCard"}
            <ImageDownload {block} />
        {:else if block.type == "topicSlider"}
            <TopicSlider {block} />
        {:else if block.type == "numbersRow"}
            <VideoTextRow {block} />
        {:else if block.type == "peopleSlider"}
            <PeopleSlider {block} />
        {:else if block.type == "skewedImageSlider"}
            <ShiftedImageSlider {block} />
        {:else if block.type == "personCards"}
            <PreviewList {block} />
        {:else if block.type == "currentNavigation"}
            {#key items}
                <NavigationCard {items} noPadding={true} animate={false} />
            {/key}
        {:else if block.type == "grayTextBlocks"}
            <GrayBoxes {block} />
        {:else if block.type == "video"}
            <VideoPreview {block} />
        {:else if block.type == "imageGallery"}
            <ImageGallery {block} />
        {:else if block.type == "creditFooterRow"}
            <CreditFooterRow {block} />
        {:else if block.type == "keypoints"}
            <Keypoints {block} />
        {:else if block.type == "articleLink"}
            <ArticleLink {block} />
        {:else if block.type == "personDetailsCards"}
            <ProfileDetailsList {block} />
        {:else if block.type == "pageNavigation"}
            <PageNavigation animate={true} />
        {:else if block.type == "table"}
            <Table table={block} />
        {:else if block.type == "image"}
            <Image {block} />
        {:else if block.type == "externalLinks"}
            <ExternalLinks {block} />
        {:else if block.type == "accordeons"}
            <ToggleBoxes {block} />
        {/if}
    </section>
{/snippet}
{#if block && !isHidden}
    {#if block.content.align_content}
        <section class="block-wrapper align-{block.content.align_content}">{@render Block()}</section>
    {:else if defaultWidthsAndAlignments[block.type]}
        <section class="block-wrapper align-{defaultWidthsAndAlignments[block.type].align_content}">
            {@render Block()}
        </section>
    {:else}
        {@render Block()}
    {/if}
{/if}

<style lang="less">
    @import "../../css/variables.less";
    section.block-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        &.align-left {
            align-items: flex-start;
        }
        &.align-right {
            align-items: flex-end;
        }
    }
    section.block {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        &.currentNavigation {
            @media @max-mobile {
                display: none;
            }
        }

        &.height-extended {
            min-height: 700px;
            @media @max-mobile {
                min-height: unset;
            }
        }
        h1,
        h2,
        h3,
        em {
            &.m-0 {
                margin-bottom: 0;
            }
            &.m-1 {
                margin-bottom: 0.5rem;
            }
            &.m-2 {
                margin-bottom: 1rem;
            }
            &.m-3 {
                margin-bottom: 1.5rem;
            }
        }

        em {
            color: rgba(36, 34, 32, 0.4);
            font-size: 0.7rem;
            font-style: normal;
            font-weight: 700;
            line-height: 1.2rem;
            text-transform: uppercase;
        }

        &.width-full {
            width: 100%;
        }
        &.width-extended {
            max-width: var(--extended-max-width);
        }
        &.width-normal {
            max-width: var(--normal-max-width);
        }
        &.width-column {
            max-width: var(--max-column-width);
        }
        &.width-sidenav {
            max-width: var(--max-sidebar-width);
        }
    }
    /* Explicit margin-top classes */
    .mt-0 {
        margin-top: 0;
    }
    .mt-1 {
        margin-top: 0.6rem;
    }
    .mt-2 {
        margin-top: 1.2rem;
    }
    .mt-3 {
        margin-top: 1.8rem;
    }
    .mt-4 {
        margin-top: 2.4rem;
    }
    .mt-5 {
        margin-top: 3rem;
    }
    .mt-6 {
        margin-top: 3.6rem;
    }
    .mt-7 {
        margin-top: 4.2rem;
    }
    .mt-8 {
        margin-top: 4.8rem;
    }
    .mt-9 {
        margin-top: 5.4rem;
    }
    .mt-10 {
        margin-top: 6rem;
    }
    .mt-11 {
        margin-top: 6.6rem;
    }

    /* Explicit margin-bottom classes */
    .mb-0 {
        margin-bottom: 0;
    }
    .mb-1 {
        margin-bottom: 0.6rem;
    }
    .mb-2 {
        margin-bottom: 1.2rem;
    }
    .mb-3 {
        margin-bottom: 1.8rem;
    }
    .mb-4 {
        margin-bottom: 2.4rem;
    }
    .mb-5 {
        margin-bottom: 3rem;
    }
    .mb-6 {
        margin-bottom: 3.6rem;
    }
    .mb-7 {
        margin-bottom: 4.2rem;
    }
    .mb-8 {
        margin-bottom: 4.8rem;
    }
    .mb-9 {
        margin-bottom: 5.4rem;
    }
    .mb-10 {
        margin-bottom: 6rem;
    }
    .mb-11 {
        margin-bottom: 6.6rem;
    }
</style>
